import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import colors from '@/styles/color.scss';
import { Scale } from '@blade/common/utils/auto-scale';
import { getPreDaysParamsIncludeToday } from '@blade-sxp/record-center/utils/date-util';
import { getDevicesList, deleteDevices, devicesBatchDelete, addLike, cancelLike, itsExport } from '@blade-sxp/its-management/api/index'; // 1TODO 权限
import { DialogType } from '@blade-sxp/its-management/interfaces/index';
import tableModel from './list-item.vue';
import uploadModel from '@blade-sxp/its-management/components/list/upload-model.vue';
import viewModel from '@blade-sxp/its-management/components/list/view-model.vue';
import InputSearch from '@blade-sxp/its-management/components/input-search.vue';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
let default_1 = class default_1 extends Vue {
    permissionlevel = permissionlevel;
    // 漏斗图标
    funnelIcon = require('@blade-sxp/task-management/assets/union.png');
    // 查询条件相关
    searchDialogVisible = false;
    protocolTypeOptions = [];
    deviceStatusOptions = [];
    initialForm = {
        dates: ['', ''],
        keyword: '',
        protocolType: '',
        deviceStatus: '',
    };
    form = { ...this.initialForm };
    // table 相关
    defaultTableMinWidth = {
        selection: 55 * Scale,
        name: 200 * Scale,
        protocolType: 130 * Scale,
        groupName: 130 * Scale,
        url: 170 * Scale,
        onlineStatus: 100 * Scale,
        direction: 130 * Scale,
        option: 325 * Scale,
    };
    selectList = [];
    uploadDialogVisible = false;
    fullSkDialogVisible = false;
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    directionAry = {
        IN: '进入',
        OUT: '离开',
        PARKING: '停车位',
    };
    viewDialogVisible = false;
    rtsp = '';
    rtsp2 = '';
    title = '';
    // 新增/编辑/详情 相关
    type = DialogType.ADD; // add/edit/view
    itemDeviceId = 0;
    itemDeviceGroupName = '';
    dialogVisible = false;
    selsectMap = new Map();
    get showExport() {
        return this.selectList.length > 0 && this.batchBtnIsShow;
    }
    groupId;
    batchBtnIsShow;
    onGroupIdChange() {
        this.onSearch();
    }
    onkeyWordChange() {
        this.onSearch();
    }
    colors = colors;
    devicesList = []; // table数据
    filterStatus = [];
    filterType = [];
    filterTypeValues = [];
    markDeviceId = '';
    tableLoading = false;
    initI18n() {
        this.filterStatus = [
            { text: this.$t('online'), value: 1 },
            { text: this.$t('offline'), value: 0 },
        ];
    }
    clearSelect() {
        this.selsectMap.clear();
        this.getSelectList();
    }
    handleFilterChange(filters) {
        this.getDevicesList();
    }
    // 批量导出
    selectTable() {
        this.selsectMap.forEach((val, key) => {
            this.devicesList.forEach((it, idx) => {
                if (it.deviceId === key) {
                    this.$nextTick(() => {
                        this.$refs.multipleTable.toggleRowSelection(it, true);
                    });
                }
            });
        });
    }
    selectChange(valList, val) {
        let isAdd = valList.length && valList.indexOf(val) !== -1;
        if (isAdd) {
            this.selsectMap.set(val.deviceId, val);
        }
        else {
            this.selsectMap.delete(val.deviceId);
        }
        this.getSelectList();
    }
    // 批量删除
    handleSelectAll(val) {
        if (val.length) {
            this.devicesList.forEach((it) => {
                this.selsectMap.set(it.deviceId, it);
            });
        }
        else {
            this.devicesList.forEach((it) => {
                this.selsectMap.delete(it.deviceId);
            });
        }
        this.getSelectList();
    }
    getSelectList() {
        this.selectList = [];
        this.selsectMap.forEach((val, key) => {
            this.selectList.push(key);
        });
    }
    handelBatchExport() {
        this.fullSkDialogVisible = true;
    }
    handleExport() {
        itsExport({ deviceIds: this.selectList })
            .then((res) => {
            window.location.href = res;
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    /**
     *@Description: 删除设备
     *@Date: 2020-09-10 18:16:47
     */
    handleDelete(sid) {
        let deviceConfirmDelete = `${this.$t('deleteMsg')}`;
        this.$elconfirm(deviceConfirmDelete, `${this.$t('deleteTitle')}`, {
            type: 'warning',
            confirmButtonText: this.$t('common.confirm').toString(),
            cancelButtonText: this.$t('common.cancel').toString(),
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    this.handleDeleteDevices(sid);
                }
            },
        });
    }
    // 删除方法
    handleDeleteDevices(deviceId) {
        try {
            deleteDevices(deviceId)
                .then((res) => {
                // this.$message.success(`${this.$t('deletedSuccessfully')}`);
                this.$message({
                    customClass: 'success-message',
                    message: this.$t('deletedSuccessfully').toString(),
                    type: 'success',
                    showClose: true,
                });
                this.getDevicesList();
                this.$emit('lick-change');
            })
                .catch((err) => {
                this.$message({ message: err, type: 'error' });
            });
        }
        catch (error) { }
    }
    // // table 的选中项
    // handleSelectionChange(val: any) {
    //   this.selectList = val;
    // }
    // // table 的全选
    // handleSelectAll(e: any) {
    //   this.selectList = e;
    // }
    // pageSize 改变时会触发
    handleSizeChange(e) {
        this.pagination.size = e;
        this.getDevicesList(true);
    }
    // currentPage 改变时会触发
    handleCurrentChange(e) {
        this.pagination.page = e;
        this.getDevicesList(true);
    }
    // 获取 table 数据
    getDevicesList(val) {
        if (!val) {
            this.clearSelect();
        }
        const { dates } = this.form;
        const { keyword, protocolType, deviceStatus, startTime, endTime } = Object.assign({}, this.form, {
            startTime: dates[0],
            endTime: dates[1],
        });
        const data = {
            groupId: this.groupId,
            keyword,
            protocolType,
            deviceStatus,
            startTime: startTime ? `${startTime} 00:00:00` : '',
            endTime: endTime ? `${endTime} 23:59:59` : '',
            page: this.pagination.page,
            size: this.pagination.size,
        };
        this.tableLoading = true;
        try {
            getDevicesList(data)
                .then((resp) => {
                this.devicesList = resp?.list || [];
                this.pagination.total = resp?.total;
                this.$nextTick(() => {
                    this.$refs.multipleTable.doLayout();
                });
            })
                .finally(() => {
                this.tableLoading = false;
                this.selectTable();
                this.getSelectList();
            });
        }
        catch (e) {
            this.tableLoading = false;
        }
    }
    // 过滤条件
    initFilters() {
        this.filterStatus = [
            { text: this.$t('online'), value: 2 },
            { text: this.$t('offline'), value: 3 },
        ];
    }
    mounted() {
        this.selsectMap.clear();
        // table 查询条件
        this.protocolTypeOptions = [{ name: 'DAHUA-DEV', value: 'DAHUA-DEV' }];
        this.deviceStatusOptions = [
            { name: `${this.$t('online')}`, value: '1' },
            { name: `${this.$t('offline')}`, value: '0' },
        ];
        // this.getDevicesList();
        this.initFilters();
    }
    // 查询条件的默认值
    pickerOptions = {
        disabledDate: (date) => moment(date).add(-1, 'days').isSameOrAfter(moment().format('YYYY-MM-DD')),
    };
    // 重置
    reset() {
        this.form = { ...this.initialForm };
        this.pagination.page = 1;
        this.onSearch();
    }
    onRefurbish() {
        this.$emit('lick-change');
        this.onSearch();
    }
    // 查询
    onSearch() {
        // this.$emit('lick-change'); // 开这个会导致左侧树频繁刷新、不能获取选中项。//为什么要加这个给忘了。
        this.pagination.page = 1;
        this.searchDialogVisible = false;
        this.getDevicesList();
    }
    getDafaultDates() {
        const { dateStart, dateEnd } = getPreDaysParamsIncludeToday(false, 6);
        return [dateStart, dateEnd];
    }
    // 批量删除
    onBatchDelete() {
        const ids = this.selectList.map((item) => item.deviceId);
        let deviceConfirmDelete = `${this.$t('deleteMsg')}`;
        let title = `${this.$t('deleteTitle')}`;
        this.$elconfirm(deviceConfirmDelete, title, {
            type: 'warning',
            confirmButtonText: this.$t('common.confirm').toString(),
            cancelButtonText: this.$t('common.cancel').toString(),
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    try {
                        devicesBatchDelete({ operateIds: ids })
                            .then((res) => {
                            // this.$message.success(`${this.$t('deletedSuccessfully')}`);
                            this.$message({
                                customClass: 'success-message',
                                message: this.$t('deletedSuccessfully').toString(),
                                type: 'success',
                                showClose: true,
                            });
                            this.onSearch();
                            this.$emit('lick-change');
                        })
                            .catch((err) => {
                            this.$message({ message: err, type: 'error' });
                        });
                    }
                    catch (error) { }
                }
            },
        });
    }
    // 批量导入
    onBatchImport() {
        // debugger;
        this.uploadDialogVisible = true;
    }
    uploadSuccse() {
        this.onSearch();
    }
    // 新增
    onAddDevice() {
        this.type = DialogType.ADD;
        this.itemDeviceGroupName = '';
        this.dialogVisible = true;
    }
    // 新增成功
    addDeviceSuccess() {
        this.$emit('msgSuccess', this.groupId);
        this.getDevicesList();
        this.$emit('lick-change');
    }
    // 编辑
    onEdit(row) {
        const { deviceId, groupName } = row;
        this.itemDeviceId = deviceId;
        this.itemDeviceGroupName = groupName;
        this.type = DialogType.EDIT;
        this.dialogVisible = true;
    }
    // 详情
    onDetails(id) {
        this.itemDeviceId = id;
        this.itemDeviceGroupName = '';
        this.type = DialogType.VIEW;
        this.dialogVisible = true;
    }
    // 库下发
    onLibraryDistributed(row) {
        const { deviceId, direction } = row;
        this.$router.push({ path: '/setting/itsManagement/detail', query: { deviceId: `${deviceId}`, direction } });
    }
    // 收藏判断
    like(device) {
        if (device.collectStatus === 'true') {
            this.cancelLike(device.deviceId);
        }
        else {
            this.addlike(device.deviceId);
        }
    }
    // 收藏功能
    addlike(deviceId) {
        addLike(deviceId).then((res) => {
            this.$message({ type: 'success', message: `${this.$t('addedFavourites')}` });
            this.getDevicesList();
            this.$emit('lick-change');
        });
    }
    // 取消收藏功能
    cancelLike(deviceId) {
        cancelLike(deviceId).then((res) => {
            this.getDevicesList();
            this.$emit('lick-change');
        });
    }
    // 查看/预览 视频
    handleView(dataItem) {
        const { rtsp } = dataItem;
        if (rtsp.length >= 2) {
            this.rtsp = rtsp[0];
            this.rtsp2 = rtsp[1];
            this.viewDialogVisible = true;
        }
        else if (rtsp.length === 1) {
            this.rtsp = rtsp[0];
            this.rtsp2 = '';
            this.viewDialogVisible = true;
        }
        else {
            this.$message.warning(`${this.$t('nortsp')}`);
        }
        // getRtsp(Number(dataItem.deviceId)).then((res: any) => {
        //   this.title = dataItem.deviceName;
        //   this.viewDialogVisible = true;
        // });
    }
    getScreenNum() {
        let num = 0;
        if (this.form.protocolType) {
            num++;
        }
        if (this.form.deviceStatus) {
            num++;
        }
        if (this.form.dates && this.form.dates[0] && this.form.dates[1]) {
            num++;
        }
        return num;
    }
};
__decorate([
    Prop()
], default_1.prototype, "groupId", void 0);
__decorate([
    Prop()
], default_1.prototype, "batchBtnIsShow", void 0);
__decorate([
    Watch('groupId')
], default_1.prototype, "onGroupIdChange", null);
__decorate([
    Watch('form.keyword')
], default_1.prototype, "onkeyWordChange", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        components: { SecondaryVerification, tableModel, uploadModel, viewModel, InputSearch, AuthNewitem },
        i18n: {
            messages: {
                'en-us': {
                    IN: 'IN',
                    OUT: 'OUT',
                    PARKING: '-',
                    deleteMsg: 'The device is already associated with this group. Are you sure you want to delete the device?',
                    online: 'Online',
                    offline: 'Offline',
                    unknown: 'unknown',
                    abnormal: 'Abnormal',
                    deleteConfirmMsg: 'Are you sure you want to delete it?',
                    addMark: 'Add Mark',
                    editMark: 'Edit Mark',
                    deletedSuccessfully: 'Deleted successfully',
                    device: 'Device',
                    keywordPlaceholder: 'Device Name/IP/Lable',
                    reset: 'Reset',
                    cancel: 'Cancel',
                    confirm: 'Confirm',
                    batchDelete: 'Delete',
                    batchImport: 'Batch Import',
                    addDevice: 'Add',
                    status: 'Status',
                    total: 'Total {msg} Items',
                    // table
                    name: 'Name',
                    protocolType: 'Protocol Type',
                    groupName: 'Group',
                    url: 'URL',
                    onlineStatus: 'Online Status',
                    direction: 'Direction',
                    option: 'Option',
                    libraryDistributed: 'Library Distributed',
                    edit: 'Edit',
                    view: 'View',
                    delete: 'Delete',
                    deleteTitle: 'system prompt',
                    addedFavourites: 'added Favourites success',
                    nortsp: 'No data source, cannot preview',
                    batchExport: 'Export',
                },
                zh: {
                    batchExport: '批量导出',
                    IN: '进',
                    OUT: '出',
                    PARKING: '-',
                    deleteMsg: '设备已与该组关联。你确定要删除该设备吗？',
                    deletedSuccessfully: '删除成功',
                    online: '在线',
                    offline: '离线',
                    unknown: '未知',
                    abnormal: '设备异常',
                    deleteConfirmMsg: '确定要删除吗？',
                    addMark: '添加标点',
                    editMark: '编辑标点',
                    device: '设备',
                    keywordPlaceholder: '设备名称/IP/标签',
                    reset: '重置',
                    cancel: '取消',
                    confirm: '确认',
                    batchDelete: '批量删除',
                    batchImport: '批量导入',
                    addDevice: '添加设备',
                    status: '状态',
                    total: '总共 {msg} 条',
                    // table
                    name: '设备名称',
                    protocolType: '协议类型',
                    groupName: '分组',
                    url: 'URL',
                    onlineStatus: '在线状态',
                    direction: '进出口方向',
                    option: '操作',
                    libraryDistributed: '库下发',
                    edit: '编辑',
                    view: '预览',
                    delete: '删除',
                    deleteTitle: '系统提示',
                    addedFavourites: '添加收藏成功',
                    nortsp: '无数据源，不可预览',
                },
            },
        },
    })
], default_1);
export default default_1;
